<template>
  <v-chip ripple :prepend-icon="assetContainerStateIcon" variant="outlined">
    {{ title ?? t('yard.messages.notInformed') }}
  </v-chip>
</template>
<script>
import { computed, defineComponent } from 'vue';
import useYard from '../../composables/useYard';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'YardViewAssetContainerStateChip',
  props: {
    value: {
      type: [String, null],
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const { t } = useI18n();
    const yardStore = useYard();

    const assetContainerStateIcon = computed(() => {
      return yardStore.getAssetContainerStateIcon(props.title);
    });

    return {
      t,
      assetContainerStateIcon
    };
  }
});
</script>
